import { ConfirmationDialog } from '@components/dialog/ConfirmationDialog';

export const INCOMPLETE_PROPOSAL_NOTICE_TEXT =
  'IMPORTANT NOTICE: THIS INDICATION REPRESENTS TERMS AND CONDITIONS BASED UPON THE INCOMPLETE INFORMATION PROVIDED TO US AT THIS TIME AND IS NOT AN OFFER OF INSURANCE BUT AN EXAMPLE OF POTENTIAL COVERAGE PROVIDED. BY CLICKING ACCEPT, YOU ACKNOWLEDGE THAT NO POLICY CAN BE BOUND UNTIL A COMPLETE AND FULLY EXECUTED LIO SPECIALTY INSURANCE COMPANY - APPLICATION FOR INSURANCE IS PROVIDED TO US. YOU FURTHER ACKNOWLEDGE THAT THE TERMS OF THIS INDICATION ARE SUBJECT TO AND LIKELY WILL CHANGE BASED UPON THE INFORMATION PROVIDED TO US IN A COMPLETE LIO SPECIALTY INSURANCE COMPANY - APPLICATION FOR INSURANCE.';

export const INCOMPLETE_PROPOSAL_CHECKBOX_TEXT =
  'I have read the notice above and acknowledge the terms therein. I accept that the indication is an example of available coverage and is subject to change upon receipt by LIO Specialty Insurance Company of additional information.';

type IncompleteProposalNoticeModalProps = {
  isOpen: boolean;
  isLoading: boolean;
  onClose: () => void;
  onAccept: () => void;
};

export const IncompleteProposalNoticeModal = ({
  isOpen,
  isLoading,
  onClose,
  onAccept,
}: IncompleteProposalNoticeModalProps) => {
  return (
    <ConfirmationDialog
      isOpen={isOpen}
      onCancel={onClose}
      description={INCOMPLETE_PROPOSAL_NOTICE_TEXT}
      checkboxText={INCOMPLETE_PROPOSAL_CHECKBOX_TEXT}
      isLoading={isLoading}
      buttonConfig={{
        confirmText: 'Accept and Download Indication',
        onConfirm: onAccept,
        secondaryText: 'Exit',
      }}
    />
  );
};
